import { useState } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    // Get dropdown value
    const serviceType = (form.querySelector('#service_type') as HTMLSelectElement)?.value;
    if (serviceType) {
      formData.set('service_type', serviceType);
    }
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d316n0qi5pmfve0ufhm0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせありがとうございます。担当者より折り返しご連絡いたします。');
        form.reset();
      } else {
        alert('送信に失敗しました。しばらくしてから再度お試しください。');
      }
    } catch {
      alert('送信に失敗しました。しばらくしてから再度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-rose-50">
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-rose-700" style={{ fontFamily: '"Pacifico", serif' }}>TSK株式会社</h1>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a href="#hero" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">ホーム</a>
              <a href="#services" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">事業内容</a>
              <a href="#strengths" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">当社の強み</a>
              <a href="#flow" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">ご利用の流れ</a>
              <a href="#company" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">会社概要</a>
              <a href="#contact" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">お問い合わせ</a>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-stone-600 hover:text-rose-600 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="md:hidden py-4 border-t border-stone-200">
              <div className="flex flex-col space-y-4">
                <a href="#hero" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">ホーム</a>
                <a href="#services" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">事業内容</a>
                <a href="#strengths" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">当社の強み</a>
                <a href="#flow" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">ご利用の流れ</a>
                <a href="#company" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">会社概要</a>
                <a href="#contact" className="text-stone-600 hover:text-rose-600 cursor-pointer whitespace-nowrap transition-colors">お問い合わせ</a>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="w-full h-full bg-gradient-to-br from-rose-100 via-amber-50 to-orange-100"></div>
          <div className="absolute inset-0" 
               style={{
                 backgroundImage: `url('https://static.readdy.ai/image/839f2161e729c94c603c4d5c071a7a67/2d9a428e6c95140f074a2256b6e6c45c.png')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center',
                 opacity: '0.6'
               }}>
          </div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center">
            <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/20">
              <div className="inline-block p-3 mb-6 bg-white/30 backdrop-blur-sm rounded-2xl">
                <div className="w-16 h-16 mx-auto bg-gradient-to-r from-rose-400 to-orange-400 rounded-full flex items-center justify-center mb-2 shadow-lg">
                  <i className="ri-heart-3-line text-2xl text-white"></i>
                </div>
              </div>
              <h2 className="text-5xl md:text-6xl font-bold text-rose-900 mb-6 leading-tight drop-shadow-sm">
                あなたの不用品を<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-600 to-orange-600">価値ある一品へ</span>
              </h2>
              <p className="text-xl md:text-2xl text-rose-800 mb-4 font-medium drop-shadow-sm">
                仕入れから販売まで、安心の物販代行サービス
              </p>
              <p className="text-lg text-stone-800 mb-8 leading-relaxed max-w-2xl mx-auto drop-shadow-sm">
                ヤフオクを中心としたEC販売と、不用品販売代行でお客様の手間を解消。<br />
                独自の仕入れルートで良品を安く仕入れ、高い成約率を実現します。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="#contact" className="bg-gradient-to-r from-rose-500 to-orange-500 text-white px-8 py-4 rounded-full text-lg font-medium hover:from-rose-600 hover:to-orange-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-center shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                  お問い合わせ
                </a>
                <a href="#services" className="border-2 border-rose-500 text-rose-700 bg-white/50 px-8 py-4 rounded-full text-lg font-medium hover:bg-rose-500 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-center shadow-md">
                  サービス詳細
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Floating elements */}
        <div className="absolute top-1/4 left-10 w-20 h-20 bg-rose-200/30 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-10 w-32 h-32 bg-orange-200/30 rounded-full blur-xl animate-pulse delay-1000"></div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block p-2 mb-4 bg-rose-100 rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-service-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-stone-800 mb-4">事業内容</h3>
            <p className="text-xl text-stone-600">お客様のニーズに応える2つの主要サービス</p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* EC物販事業 */}
            <div className="group hover:scale-105 transition-all duration-300">
              <div className="bg-gradient-to-br from-rose-50 to-orange-50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-rose-100">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-rose-400 to-orange-400 rounded-2xl flex items-center justify-center mr-4 shadow-lg">
                    <i className="ri-shopping-cart-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-rose-800">EC物販事業</h4>
                </div>
                <div className="relative overflow-hidden rounded-2xl mb-6 shadow-md">
                  <img src="https://public.readdy.ai/ai/img_res/fcdaaeb256aa0c4b137e0b506a346a53.jpg" 
                       alt="EC物販事業" className="w-full h-48 object-cover hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-rose-900/20 to-transparent"></div>
                </div>
                <div className="space-y-4">
                  <p className="text-stone-700 leading-relaxed">
                    ヤフオクなどの大手ECサイトを通じて、選び抜いた商品を販売しています。
                  </p>
                  <p className="text-stone-700 leading-relaxed">
                    代表は「道具市」の独自ルートを持っており、質の高い品を相場より安く仕入れることが可能です。
                  </p>
                  <div className="bg-white/50 rounded-xl p-4 border border-rose-200">
                    <p className="text-rose-700 font-medium">
                      そのため、お客様に「安心価格 × 高品質」の商品をお届けできます。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 不用品販売代行 */}
            <div className="group hover:scale-105 transition-all duration-300">
              <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-emerald-100">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-2xl flex items-center justify-center mr-4 shadow-lg">
                    <i className="ri-recycle-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-emerald-800">不用品販売代行</h4>
                </div>
                <div className="relative overflow-hidden rounded-2xl mb-6 shadow-md">
                  <img src="https://readdy.ai/api/search-image?query=Organized%20collection%20of%20valuable%20second-hand%20items%20in%20soft%20emerald%20and%20teal%20color%20scheme%2C%20professional%20product%20staging%20with%20gentle%20lighting%2C%20various%20household%20items%20arranged%20elegantly%20on%20cream%20background%2C%20professional%20consignment%20service%20atmosphere%20with%20warm%20pastel%20colors&width=600&height=400&seq=consign2&orientation=landscape" 
                       alt="不用品販売代行" className="w-full h-48 object-cover hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 to-transparent"></div>
                </div>
                <div className="space-y-4">
                  <p className="text-stone-700 leading-relaxed">
                    「もう使わなくなったけど、まだ売れるかも…」そんな品物を代わりに販売いたします。
                  </p>
                  <div className="space-y-3">
                    {[
                      '出品手続き不要',
                      '撮影・商品説明・やり取りまで一括代行',
                      '売れた利益から手数料をいただく、わかりやすい仕組み'
                    ].map((item, index) => (
                      <div key={index} className="flex items-center bg-white/60 rounded-lg p-3 border border-emerald-200">
                        <div className="w-6 h-6 bg-emerald-400 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                          <i className="ri-check-line text-sm text-white"></i>
                        </div>
                        <span className="text-stone-700">{item}</span>
                      </div>
                    ))}
                  </div>
                  <div className="bg-white/50 rounded-xl p-4 border border-emerald-200">
                    <p className="text-emerald-700 font-medium">
                      個人の方だけでなく、法人や店舗の余剰在庫処理なども対応可能です。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Strengths Section */}
      <section id="strengths" className="py-20 bg-gradient-to-br from-stone-50 to-rose-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block p-2 mb-4 bg-rose-100 rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-star-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-stone-800 mb-4">当社の強み</h3>
            <p className="text-xl text-stone-600">なぜTSK株式会社が選ばれるのか</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-medal-line', title: '確かな仕入れルート', desc: '道具市の資格を持つ確かな仕入れルート', color: 'from-rose-400 to-pink-400' },
              { icon: 'ri-line-chart-line', title: '豊富な販売実績', desc: 'ヤフオクで培った豊富な販売実績', color: 'from-emerald-400 to-teal-400' },
              { icon: 'ri-money-dollar-circle-line', title: '成果報酬型', desc: '完全成果報酬型の代行手数料システム', color: 'from-amber-400 to-orange-400' },
              { icon: 'ri-customer-service-2-line', title: '誠実な対応', desc: 'スピーディーで誠実な対応', color: 'from-purple-400 to-pink-400' }
            ].map((item, index) => (
              <div key={index} className="group hover:scale-105 transition-all duration-300">
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-2xl text-center h-full border border-stone-200 hover:border-rose-200 transition-all duration-300">
                  <div className={`w-16 h-16 bg-gradient-to-r ${item.color} rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300`}>
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <h5 className="text-lg font-bold text-stone-800 mb-3">{item.title}</h5>
                  <p className="text-stone-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Flow Section */}
      <section id="flow" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block p-2 mb-4 bg-rose-100 rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-route-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-stone-800 mb-4">ご利用の流れ</h3>
            <p className="text-xl text-stone-600">簡単5ステップでご利用いただけます</p>
          </div>

          <div className="max-w-4xl mx-auto">
            {[
              { step: 1, title: 'お問い合わせ', desc: 'お電話またはお問い合わせフォームからご連絡ください', icon: 'ri-phone-line', color: 'from-rose-400 to-pink-400' },
              { step: 2, title: '商品のお預かり・査定', desc: '商品をお預かりし、市場価値を査定いたします', icon: 'ri-search-eye-line', color: 'from-emerald-400 to-teal-400' },
              { step: 3, title: '撮影・出品（代行の場合）', desc: '商品撮影から出品まで、全て代行いたします', icon: 'ri-camera-line', color: 'from-amber-400 to-orange-400' },
              { step: 4, title: '販売・落札', desc: '最適なタイミングで販売し、高値での落札を目指します', icon: 'ri-auction-line', color: 'from-purple-400 to-pink-400' },
              { step: 5, title: '売上から手数料を差し引いてご精算', desc: '売上から手数料を差し引いた金額をお支払いします', icon: 'ri-money-yen-circle-line', color: 'from-indigo-400 to-purple-400' }
            ].map((item, index) => (
              <div key={index} className="relative">
                <div className="flex items-center group hover:scale-102 transition-all duration-300">
                  <div className="flex-shrink-0">
                    <div className={`w-20 h-20 bg-gradient-to-r ${item.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300`}>
                      <span className="text-white font-bold text-2xl">{item.step}</span>
                    </div>
                  </div>
                  <div className="ml-8 flex-1 bg-gradient-to-r from-stone-50 to-rose-50 rounded-2xl p-6 border border-stone-200 group-hover:border-rose-200 transition-all duration-300">
                    <div className="flex items-center mb-3">
                      <div className="w-8 h-8 flex items-center justify-center mr-3">
                        <i className={`${item.icon} text-xl text-rose-600`}></i>
                      </div>
                      <h5 className="text-xl font-bold text-stone-800">{item.title}</h5>
                    </div>
                    <p className="text-stone-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
                {index < 4 && (
                  <div className="flex justify-center my-4">
                    <div className="w-1 h-8 bg-gradient-to-b from-rose-300 to-orange-300 rounded-full"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CEO Message */}
      <section className="py-20 bg-gradient-to-br from-rose-50 to-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-block p-2 mb-4 bg-rose-100 rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-user-heart-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-stone-800 mb-4">代表取締役挨拶</h3>
          </div>
          
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-rose-100">
            <div className="text-center mb-8">
              <h4 className="text-3xl font-bold text-stone-800 mb-2">中川 大輔</h4>
              <p className="text-xl text-rose-600 font-medium">代表取締役</p>
            </div>
            
            <div className="space-y-6 text-stone-700 leading-relaxed max-w-3xl mx-auto">
              <p className="text-lg">
                このたびは、TSK株式会社のホームページをご覧いただき、誠にありがとうございます。
              </p>
              <p>
                当社は「良い品をより多くの方に、適正な価格で届けたい」という思いをもとに、EC販売と不用品販売代行事業を展開しております。
              </p>
              <p>
                私自身、長年にわたり道具市での仕入れを行い、良い商品を見極める目を磨いてまいりました。その経験を活かし、ヤフオクを中心とした販売で数多くのお客様とご縁をいただいております。
              </p>
              <p>
                また、不用品販売代行サービスでは「手間がかかる」「どう出品していいかわからない」といったお客様のお悩みを解決し、眠っている品物を新たな価値へとつなげるお手伝いをしております。
              </p>
              <div className="bg-gradient-to-r from-rose-50 to-orange-50 rounded-2xl p-6 border border-rose-200 text-center">
                <p className="font-medium text-rose-700 text-lg">
                  今後も誠実な対応と確かな実績を積み重ね、皆さまに信頼されるパートナー企業を目指してまいります。どうぞTSK株式会社をよろしくお願い申し上げます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section id="company" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block p-2 mb-4 bg-rose-100 rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-building-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-stone-800 mb-4">会社概要</h3>
          </div>

          <div className="bg-gradient-to-br from-stone-50 to-rose-50 rounded-3xl p-8 shadow-2xl max-w-4xl mx-auto border border-rose-100">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-6">
                {[
                  { label: '会社名', value: 'TSK株式会社（ティーエスケー）' },
                  { label: '代表取締役', value: '中川 大輔' },
                  { label: '資本金', value: '100万円' }
                ].map((item, index) => (
                  <div key={index} className="bg-white/60 rounded-2xl p-4 border border-rose-200">
                    <dt className="text-sm font-medium text-rose-600 mb-2">{item.label}</dt>
                    <dd className="text-lg text-stone-800 font-medium">{item.value}</dd>
                  </div>
                ))}
              </div>
              
              <div className="space-y-6">
                <div className="bg-white/60 rounded-2xl p-4 border border-rose-200">
                  <dt className="text-sm font-medium text-rose-600 mb-2">住所</dt>
                  <dd className="text-lg text-stone-800 font-medium leading-relaxed">
                    〒554-0034<br />
                    大阪市生野区桃谷1-1-13<br />
                    リブコートマキ103号室
                  </dd>
                </div>
                <div className="bg-white/60 rounded-2xl p-4 border border-rose-200">
                  <dt className="text-sm font-medium text-rose-600 mb-2">連絡先</dt>
                  <dd className="text-lg font-medium">
                    <a href="tel:080-4387-5252" className="text-rose-600 hover:text-rose-800 cursor-pointer transition-colors">
                      080-4387-5252
                    </a>
                  </dd>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-br from-stone-800 to-rose-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="w-full h-full bg-gradient-to-br from-rose-400 to-orange-400"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-block p-2 mb-4 bg-white/20 backdrop-blur-sm rounded-2xl">
              <div className="w-12 h-12 bg-gradient-to-r from-rose-400 to-orange-400 rounded-xl flex items-center justify-center">
                <i className="ri-mail-line text-xl text-white"></i>
              </div>
            </div>
            <h3 className="text-4xl font-bold text-white mb-4">お問い合わせ</h3>
            <p className="text-xl text-rose-200">「不用品を売りたい」「仕入れ・販売を任せたい」などお気軽にご相談ください。</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 shadow-2xl border border-rose-200">
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit}>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-stone-700 mb-2">
                    お名前 <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-rose-200 rounded-2xl focus:ring-2 focus:ring-rose-400 focus:border-transparent text-sm bg-white/80 backdrop-blur-sm transition-all duration-300"
                    placeholder="山田太郎"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-stone-700 mb-2">
                    メールアドレス <span className="text-rose-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-rose-200 rounded-2xl focus:ring-2 focus:ring-rose-400 focus:border-transparent text-sm bg-white/80 backdrop-blur-sm transition-all duration-300"
                    placeholder="example@email.com"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-stone-700 mb-2">
                    電話番号
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-rose-200 rounded-2xl focus:ring-2 focus:ring-rose-400 focus:border-transparent text-sm bg-white/80 backdrop-blur-sm transition-all duration-300"
                    placeholder="090-1234-5678"
                  />
                </div>
                <div>
                  <label htmlFor="service_type" className="block text-sm font-medium text-stone-700 mb-2">
                    ご希望のサービス <span className="text-rose-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      id="service_type"
                      name="service_type"
                      required
                      className="w-full px-4 py-3 pr-8 border border-rose-200 rounded-2xl focus:ring-2 focus:ring-rose-400 focus:border-transparent text-sm appearance-none bg-white/80 backdrop-blur-sm transition-all duration-300"
                    >
                      <option value="">選択してください</option>
                      <option value="不用品販売代行">不用品販売代行</option>
                      <option value="EC物販事業">EC物販事業</option>
                      <option value="その他">その他</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <i className="ri-arrow-down-s-line text-rose-400"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-stone-700 mb-2">
                  お問い合わせ内容 <span className="text-rose-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={6}
                  className="w-full px-4 py-3 border border-rose-200 rounded-2xl focus:ring-2 focus:ring-rose-400 focus:border-transparent text-sm resize-none bg-white/80 backdrop-blur-sm transition-all duration-300"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                ></textarea>
                <p className="text-xs text-stone-500 mt-1">※500文字以内でご入力ください</p>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-rose-400 to-orange-400 text-white px-8 py-4 rounded-2xl text-lg font-medium hover:from-rose-500 hover:to-orange-500 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                送信する
              </button>
            </form>
          </div>

          <div className="text-center mt-8">
            <p className="text-rose-200 mb-2">お電話でのお問い合わせ</p>
            <a href="tel:080-4387-5252" className="text-2xl font-bold text-white hover:text-rose-200 cursor-pointer transition-colors">
              080-4387-5252
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-stone-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-2xl font-bold mb-4 text-rose-400" style={{ fontFamily: '"Pacifico", serif' }}>TSK株式会社</h4>
              <p className="text-stone-400 leading-relaxed">
                良い品をより多くの方に、適正な価格で届けたい
              </p>
            </div>
            
            <div>
              <h5 className="text-lg font-bold mb-4 text-rose-400">サービス</h5>
              <ul className="space-y-2 text-stone-400">
                <li><a href="#services" className="hover:text-rose-300 cursor-pointer transition-colors">EC物販事業</a></li>
                <li><a href="#services" className="hover:text-rose-300 cursor-pointer transition-colors">不用品販売代行</a></li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-lg font-bold mb-4 text-rose-400">お問い合わせ</h5>
              <div className="text-stone-400 space-y-2 leading-relaxed">
                <p>〒554-0034</p>
                <p>大阪市生野区桃谷1-1-13</p>
                <p>リブコートマキ103号室</p>
                <p>
                  <a href="tel:080-4387-5252" className="hover:text-rose-300 cursor-pointer transition-colors">
                    080-4387-5252
                  </a>
                </p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-stone-800 mt-8 pt-8 text-center text-stone-400">
            <p>&copy; 2024 TSK株式会社. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
